export class AuthModel {
  access_token: string;
  refreshToken: string;
  expiresIn: Date;

  setAuth(auth: AuthModel) {
    this.access_token = auth.access_token;
    this.refreshToken = auth.refreshToken;
    this.expiresIn = auth.expiresIn;
  }
}

export enum AuthState {
  UNAUTHORIZED = "unauthorized",
  AUTHORIZED = "authorized",
  FORGOT_PASSWORD = "forgot_password",
  REGISTER = "register",
}
